import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ljtj_icon",
  "use": "icon-ljtj_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-ljtj_icon\">\n<title>ljtj_icon</title>\n<path d=\"M21.045 2.286h-17.616v27.429h25.143v-19.908l-7.527-7.52zM20.098 4.571l6.187 6.183v16.674h-20.571v-22.857h14.384z\" />\n<path d=\"M17.143 12.571v11.429h-2.286v-11.429z\" />\n<path d=\"M10.62 16.335l5.38-5.38 5.38 5.38-1.616 1.616-3.763-3.764-3.763 3.764z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol